/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantUpdatePatchSpec { 
    /**
     * Unique identifier for the tenant.
     */
    id: number;
    orgId?: string;
    erpId?: string;
    /**
     * True if org has tib subscription, false otherwise
     */
    hasDeployment?: boolean;
    /**
     * Last processing date saved by VLR daily org summary
     */
    vlrOrgSummaryLastProcessingDt?: string;
    /**
     * Last processing date saved by VMC daily org summary
     */
    vmcOrgSummaryLastProcessingDt?: string;
    /**
     * Last reconcile/refresh date saved by VMC daily org summary
     */
    lastVmcRefreshDt?: string;
}

